import { getJson } from './client'
import type { DashboardView } from '../types/dashboard'

// The landing dashboard: what the signed-in rep has in flight, who to reach next and why, the shape of the
// week. First-person by contract — the API reads the rep's own pipeline — so the org the sidebar has selected
// is deliberately NOT sent (passing org: undefined is how a GET says the question has no org).
const dashboard = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/dashboard`

export const dashboardApi = {
  // the org being looked at rides along like every other GET (owner, 2026-10-12: the org is a site-wide filter)
  get: (spoke: string) => getJson<DashboardView>(dashboard(spoke)),
}
